import { DISTANCE_UNITS } from "./DistanceUnit";

export const getRadiusDefaultValueByDistanceUnit = (distanceUnit) => {
  const defaultValue = {
    [DISTANCE_UNITS.METER]: 5000,
    [DISTANCE_UNITS.MILE]: 3.1,
  };
  return defaultValue[distanceUnit.unit] || defaultValue[DISTANCE_UNITS.METER];
};
